import React, { Suspense } from "react";
import { Skeleton } from "antd";

export const SuspenseSkeleton = ({children}: any) => {
    return <Suspense fallback={<Skeleton active/>}>{children}</Suspense>
};
